var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        label: _vm.label,
        "label-for": _vm.inputId,
        description: _vm.description
      }
    },
    [
      _c(
        "b-form-select",
        {
          attrs: {
            id: _vm.inputId,
            options: _vm.leadsExtractedOptions,
            required: _vm.required,
            state: _vm.isValid
          },
          on: { change: _vm.handleChange, blur: _vm.handleBlur },
          model: {
            value: _vm.internalValue,
            callback: function($$v) {
              _vm.internalValue = $$v
            },
            expression: "internalValue"
          }
        },
        [
          _c("option", { attrs: { disabled: "", value: "" } }, [
            _vm._v("Selecione...")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-form-invalid-feedback",
        { attrs: { id: `${_vm.inputId}-feedback` } },
        [_vm._v("\n    " + _vm._s(_vm.invalidFeedback) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }